import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Countdown } from './ui/Countdown';
import { AnimatedSection } from './ui/AnimatedSection';
export function UrgencyBlock() {
  return <AnimatedSection className="pb-10 pt-20" data-id="element-371">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-372">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-white mb-6 sm:mb-8 uppercase tracking-wide leading-tight" data-id="element-373">
          ⏰ Precio de Lanzamiento — Cierra en:
        </h2>

        <Countdown data-id="element-374" />

        <div className="mt-6 sm:mt-8 flex items-center justify-center gap-2 text-gold font-semibold text-sm sm:text-base md:text-lg bg-gold/10 inline-flex px-4 sm:px-6 py-2 sm:py-3 rounded-full border border-gold/20" data-id="element-375">
          <AlertCircle size={18} className="flex-shrink-0" data-id="element-376" />
          <span data-id="element-377">Después sube $15.000 ARS. No vuelve.</span>
        </div>

        <div className="mt-8 sm:mt-10 max-w-md mx-auto" data-id="element-378">
          <div className="flex justify-between text-xs sm:text-sm font-bold mb-2" data-id="element-379">
            <span className="text-red-400 flex items-center gap-1.5 sm:gap-2" data-id="element-380">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-381"></span>{' '}
              Cupos al precio de lanzamiento
            </span>
            <span className="text-gray-400" data-id="element-382">Quedan pocos</span>
          </div>
          <div className="h-3 sm:h-4 bg-navy-900 rounded-full overflow-hidden border border-dark-border" data-id="element-383">
            <div className="h-full bg-gradient-to-r from-red-600 to-red-400 w-[68%] rounded-full relative" data-id="element-384">
              <div className="absolute inset-0 bg-white/20 animate-[pulse_2s_ease-in-out_infinite]" data-id="element-385"></div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-386">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </AnimatedSection>;
}